import { useDispatch } from 'react-redux';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { IPoint } from '@/_store/common/types';
import { onOpenMap } from '@/_store/common/common.slice';
import { HStack, Presence, Text, VStack } from '@chakra-ui/react';
import { sessionActions } from '@/_store/session/session.slice';

interface IProps {
  open: boolean;
  activePoint: IPoint | null;
  onClose: () => void;
}

export default function Mobile({ open, activePoint, onClose }: IProps) {
  const t = useTranslations();
  const dispatch = useDispatch();

  if (activePoint?.address) {
    return (
      <SavedPopover
        open={open}
        address={activePoint?.address}
        onClose={onClose}
      />
    );
  }

  return (
    <Presence
      zIndex={50}
      position='fixed'
      top='0'
      insetX='0'
      present={open}
      animationName={{
        _open: 'slide-from-top-full',
        _closed: 'slide-to-top-full',
      }}
      animationDuration='moderate'
    >
      <VStack
        textAlign='center'
        roundedBottom='2xl'
        bgColor='background.card'
        color='text'
        gap={3}
        p='4'
      >
        <div>
          <Text fontSize='xl' fontWeight={700} lineHeight={1} mb='2px'>
            {t('location.enter_delivery_address')}
          </Text>
          <Text fontSize='xs'>{t('location.with_the_address')}</Text>
        </div>
        <HStack>
          <Button bgColor='gray.200' variant='subtle' onClick={onClose}>
            {t('location.later')}
          </Button>
          <Button
            bgColor='primary'
            justifyContent='space-between'
            onClick={() => {
              dispatch(onOpenMap());
              onClose();
            }}
          >
            {t('location.enter_address')}
          </Button>
        </HStack>
      </VStack>
    </Presence>
  );
}

function SavedPopover({
  open,
  address,
  onClose,
}: {
  open: boolean;
  address: string;
  onClose: () => void;
}) {
  const dispatch = useDispatch();
  const t = useTranslations('location');

  return (
    <Presence
      zIndex={50}
      position='fixed'
      top='0'
      insetX='0'
      present={open}
      animationName={{
        _open: 'slide-from-top-full',
        _closed: 'slide-to-top-full',
      }}
      animationDuration='moderate'
    >
      <VStack
        textAlign='center'
        roundedBottom='2xl'
        bgColor='background.card'
        color='text'
        gap={3}
        p='4'
      >
        <div>
          <Text fontSize='xs'>{t('order_to_this_address?')}</Text>
          <Text fontSize='lg' fontWeight={700} lineHeight={1} mt='2px'>
            {address}
          </Text>
        </div>
        <HStack>
          <Button
            bgColor='gray.200'
            variant='subtle'
            onClick={() => dispatch(onOpenMap())}
          >
            {t('no')}
          </Button>
          <Button
            bgColor='primary'
            justifyContent='space-between'
            onClick={() => {
              dispatch(sessionActions.acceptPGL());
              onClose();
            }}
          >
            {t('yes')}
          </Button>
        </HStack>
      </VStack>
    </Presence>
  );
}
